/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceColumnPosition {
    getFixupPrototypeFunction() { return ResourceColumnPosition.fixupPrototype; }

    static newInstance(model: Partial<ResourceColumnPosition>): ResourceColumnPosition {
        let obj = Object.assign(new ResourceColumnPosition(), model);
        ResourceColumnPosition.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceColumnPosition>): ResourceColumnPosition {
        if (!model) return null;
        return ResourceColumnPosition.newInstance(<ResourceColumnPosition> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceColumnPosition) {
        if (!obj) return;

        models.ResourceColumnPosition.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceColumnPosition): boolean {
        Object.setPrototypeOf(obj, ResourceColumnPosition.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.position === undefined) {
            this.position = 0;
        }
    }

    /**
     * Column identifier
     */
    id: string;

    /**
     * Column heading
     */
    label: string;

    /**
     * Path of the column value in the record
     */
    ref: string;

    /**
     * Column position
     */
    position: number;

    /**
     * Whether the column is shown by default
     */
    visible: boolean;

}
